import React from 'react';

import { StyledAvatarWrapper, StyledCircle, StyledCollectionName, StyledCollectionVolume, StyledContentWrapper, StyledImage, StyledWrapper } from './top-collection-card-preloader.styles';

export const TopCollectionCardPreloader = ({ rankingPosition }: { rankingPosition: number }) => (
    <StyledWrapper alignItems='center'>
        <StyledAvatarWrapper>
            <StyledImage width={40} height={40} />
            <StyledCircle>{rankingPosition}</StyledCircle>
        </StyledAvatarWrapper>
        <StyledContentWrapper>
            <StyledCollectionName />
            <StyledCollectionVolume />
        </StyledContentWrapper>
    </StyledWrapper>
);